var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-header",class:{ sticky: _vm.sticky, fullscreen: _vm.fullscreen, }},[_c('div',{staticClass:"modal-header-leading"},[_vm._t("leading")],2),_c('div',{staticClass:"modal-header-main"},[_vm._t("title")],2),_c('div',{staticClass:"modal-header-trailing"},[_vm._t("trailing")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }